export interface NotifyModel
{
    action:NotifyType;
    data?:object;
    code?:number;
}

export enum NotifyType
{
   Disconnected ="disconnect", ///断开连接
   Conn = "conn", ///用户验证信息
   JoinVideoRoom = "joinVideoRoom", ///加入视频房间
   LeaveVideoRoom="leaveVideoRoom",///退出视频房间
   SendBarrage="sendBarrage", ///发送弹幕，
   GetBarrage = "getBarrage", ///接受弹幕
   UserStateChange = "userStateChange", ///用户状态更改
   PrivateMessage = "privateMessage",////私信
   UserLiveTest = "userLiveTest"///异地登录
}